import { render, staticRenderFns } from "./LanguageSelectorItem.vue?vue&type=template&id=2d70d7ec&scoped=true"
import script from "./LanguageSelectorItem.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorItem.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectorItem.vue?vue&type=style&index=0&id=2d70d7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70d7ec",
  null
  
)

export default component.exports